import { Text } from '../../../components';
import {
  DotIcon,
  FileDotedIcon,
  FileTextIcon,
} from '../../../components/icons';
import React from 'react';
import {
  DotIconStyle,
  MeetingItemRightStyle,
  MeetingItemStyle,
} from '../styles';
import { E_TransactionStatus } from '@repo-sapiens/data-access-models';
import { css } from '@emotion/css';
import { theme } from '@repo-sapiens/theme';

const getBotStateComoponent = (
  state?: E_TransactionStatus,
  statusDisabled?: boolean
) => {
  switch (state) {
    case E_TransactionStatus.Canceled:
      return (
        <div
          className={css`
            width: 28px;
            height: 28px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            border: 1px solid ${theme.colors.text.darkGrey};
            margin-left: 8px;
            cursor: ${statusDisabled ? 'not-allowed' : 'pointer'};
          `}
        >
          <FileDotedIcon
            fill="darkGrey"
            style={{ width: '18px', height: '18px' }}
          />
        </div>
      );
    case E_TransactionStatus.Completed:
    case E_TransactionStatus.UserCompleted:
      return (
        <div
          className={css`
            width: 28px;
            height: 28px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            border: 1px solid ${theme.colors.text['highlight/1']};
            margin-left: 8px;
            cursor: pointer;
          `}
        >
          <FileTextIcon
            fill="highlight/1"
            style={{ width: '18px', height: '18px' }}
          />
        </div>
      );
    case E_TransactionStatus.Initiated:
    case E_TransactionStatus.InProgress:
      return (
        <div
          className={css`
            width: 28px;
            height: 28px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            border: 1px solid ${theme.colors.text['highlight/3']};
            margin-left: 8px;
            cursor: pointer;
          `}
        >
          <FileDotedIcon
            fill="highlight/3"
            style={{ width: '18px', height: '18px' }}
          />
        </div>
      );

    default:
      return (
        <div
          className={css`
            width: 28px;
            height: 28px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            border: 1px solid ${theme.colors.text.darkGrey};
            margin-left: 8px;
            cursor: pointer;
          `}
        >
          <FileDotedIcon
            fill="darkGrey"
            style={{ width: '18px', height: '18px' }}
          />
        </div>
      );
  }
};

type Props = {
  title: string;
  startTime: string;
  botStatus?: E_TransactionStatus;
  statusDisabled?: boolean;
  type: string;
  id?: string;
  onClick?: () => void;
  onBotStatusClick?: (botStatus?: E_TransactionStatus) => void;
};
export const MeetingListItem: React.FC<Props> = ({
  title,
  startTime,
  type,
  botStatus,
  statusDisabled,
  onClick,
  onBotStatusClick,
}) => {
  const handleStatusClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    if (onBotStatusClick) {
      onBotStatusClick(botStatus);
    }
  };

  return (
    <div className={MeetingItemStyle} onClick={onClick}>
      <Text.BodyXS>{title}</Text.BodyXS>
      <div className={MeetingItemRightStyle}>
        <Text.BodyXS color="tertiary">{startTime}</Text.BodyXS>
        <DotIcon fill="tertiary" style={DotIconStyle} />
        <Text.BodyXS color="highlight/1">{type}</Text.BodyXS>

        <div onClick={handleStatusClick}>
          {getBotStateComoponent(botStatus, statusDisabled)}
        </div>
      </div>
    </div>
  );
};
